import React, { useState } from "react";
import { Table, Spinner, Alert, Input, Button } from "reactstrap";
import axiosInstance from "../../request";
import { URL } from "../../api";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const BureauReporting = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [loanId, setLoanId] = useState("");
  const [customerId, setCustomerId] = useState("");
  const [filterType, setFilterType] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  // Fixed column list
  const columns = [
    "Consumer Name",
    "Date of Birth",
    "Gender",
    "fintech_name",
    "Income Tax ID Number",
    "Passport Number",
    "Passport Issue Date",
    "Passport Expiry Date",
    "Voter ID Number",
    "Driving License Number",
    "Driving License Issue Date",
    "Driving License Expiry Date",
    "Ration Card Number",
    "Universal ID Number",
    "Additional ID #1",
    "Additional ID #2",
    "Mobile Number",
    "Telephone No.Residence",
    "Telephone No.Office",
    "Extension Office",
    "Telephone No.Other",
    "Extension Other",
    "Email ID 1",
    "Email ID 2",
    "Address Line 1",
    "State Code 1",
    "PIN Code 1",
    "Residence Code 1",
    "Address Line 2",
    "State Code 2",
    "PIN Code 2",
    "Residence Code 2",
    "Current/New Member Code",
    "Current/New Member Short Name",
    "Curr/New Account No",
    "Account Type",
    "Ownership Indicator",
    "Date Opened/Disbursed",
    "Date of Last Payment",
    "Date Closed",
    "Date Reported",
    "High Credit/Sanctioned Amt",
    "Current Balance",
    "Amt Overdue",
    "No of Days Past Due",
    "Old Mbr Code",
    "Old Mbr Short Name",
    "Old Acc No",
    "Old Acc Type",
    "Old Ownership Indicator",
    "Suit Filed / Wilful Default",
    "Credit Facility Status",
    "Asset Classification",
    "Value of Collateral",
    "Type of Collateral",
    "Credit Limit",
    "Cash Limit",
    "Rate of Interest",
    "Repayment Tenure",
    "EMI Amount",
    "Written-off Amount (Total)",
    "Written-off Principal Amount",
    "Settlement Amt",
    "Payment Frequency",
    "Actual Payment Amt",
    "Occupation Code",
    "Income",
    "Net/Gross Income Indicator",
    "Monthly/Annual Income Indicator",
    "CKYC",
    "NREGA Card Number",
  ];

  // Fetch Bureau Data
  const fetchBureauData = async () => {
    setError("");
    setLoading(true);
    try {
      const params = {};

      if (loanId) params.loanId = loanId;
      if (customerId) params.customerId = customerId;
      if (fromDate) params.fromDate = fromDate;
      if (toDate) params.toDate = toDate;

     const res = await axiosInstance.get(URL.BUREAU_REPORTING, { params });
const result = res.data;

if (result?.content && Array.isArray(result.content) && result.content.length > 0) {
  setData(result.content);
} else if (result?.message) {
  setData([{ message: result.message }]);
} else {
  setData([{ message: "No data found." }]);
}
    } catch (err) {
      setError("Failed to fetch Bureau Reporting data.");
    } finally {
      setLoading(false);
    }
  };

  // Handle Enter Key
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      fetchBureauData();
    }
  };

  // Export to Excel
  const exportToExcel = () => {
    if (!data || data.length === 0 || data[0]?.message) return;
    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Bureau Report");
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, "Bureau_Report.xlsx");
  };

  return (
    <>
      {/* ===== Filters ===== */}
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "15px",
          marginBottom: "20px",
          alignItems: "flex-end",
        }}
      >
        {/* Filter Type Dropdown
        <div style={{ display: "flex", flexDirection: "column" }}>
          <label style={{ fontSize: "12px", fontWeight: "500" }}>Filter Type</label>
          <Input
            type="select"
            value={filterType}
            onChange={(e) => {
              setFilterType(e.target.value);
              setLoanId("");
              setCustomerId("");
            }}
            style={{ fontSize: "12px", fontWeight: "500" }}
          >
            <option value="">Select Filter</option>
            <option value="loanId">Loan ID</option>
            <option value="customerId">Customer ID</option>
          </Input>
        </div> */}

        {/* Conditional Filter Input */}
        {filterType && (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <label style={{ fontSize: "12px", fontWeight: "500" }}>
              {filterType === "loanId" ? "Loan ID" : "Customer ID"}
            </label>
            <Input
              type="number"
              placeholder={`Enter ${filterType === "loanId" ? "Loan ID" : "Customer ID"}`}
              value={filterType === "loanId" ? loanId : customerId}
              onChange={(e) =>
                filterType === "loanId"
                  ? setLoanId(e.target.value)
                  : setCustomerId(e.target.value)
              }
              onKeyDown={handleKeyDown} // 🔹 Trigger search on Enter
              style={{ fontSize: "12px", fontWeight: "500" }}
            />
          </div>
        )}

        {/* From Date */}
        <div style={{ display: "flex", flexDirection: "column" }}>
          <label style={{ fontSize: "12px", fontWeight: "500" }}>From Date</label>
          <Input
            type="date"
            value={fromDate}
            onChange={(e) => setFromDate(e.target.value)}
            onKeyDown={handleKeyDown} // 🔹 Trigger on Enter
            style={{ fontSize: "12px", fontWeight: "500" }}
          />
        </div>

        {/* To Date */}
        <div style={{ display: "flex", flexDirection: "column" }}>
          <label style={{ fontSize: "12px", fontWeight: "500" }}>To Date</label>
          <Input
            type="date"
            value={toDate}
            onChange={(e) => setToDate(e.target.value)}
            onKeyDown={handleKeyDown}
            style={{ fontSize: "12px", fontWeight: "500" }}
          />
        </div>

        {/* Search Button */}
        <div style={{ display: "flex", flexDirection: "column" }}>
          <label>&nbsp;</label>
          <Button
            color="primary"
            onClick={fetchBureauData}
            disabled={loading}
            style={{ fontSize: "12px", fontWeight: "500" }}
          >
            {loading ? "Loading..." : "Search"}
          </Button>
        </div>

        {/* Export Button */}
        <div style={{ display: "flex", flexDirection: "column" }}>
          <label>&nbsp;</label>
          <Button
            color="success"
            onClick={exportToExcel}
            disabled={data.length === 0 || data[0]?.message}
            style={{ fontSize: "12px", fontWeight: "500" }}
          >
            Export Excel
          </Button>
        </div>
      </div>

      {/* ===== Error Handling ===== */}
      {error && <Alert color="danger">{error}</Alert>}

      {/* ===== Table ===== */}
      {loading ? (
        <Spinner />
      ) : (
        <div style={{ overflowX: "auto", width: "100%" }}>
          <Table bordered striped hover responsive style={{ whiteSpace: "nowrap" }}>
            <thead>
              <tr>
                <th>S.No.</th>
                {columns.map((col, i) => (
                  <th key={i}>{col}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {data.length > 0 && !data[0]?.message ? (
                data.map((row, i) => (
                  <tr key={i}>
                    <td>{i + 1}</td>
                    {columns.map((col, j) => (
                      <td key={j}>{row[col] !== null && row[col] !== undefined ? row[col] : ""}</td>
                    ))}
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={columns.length + 1} style={{ textAlign: "center" }}>
                    {data[0]?.message || "No data found."}
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      )}
    </>
  );
};

export default BureauReporting;
